module.exports = __webpack_public_path__ + "static/media/tip_cat_flea.b9566ef2.png";